export default function toInt(val: any, fallback?: number) {
    const int = parseInt(val, 10);
    return !Number.isNaN(int) ? int : fallback || 0;
}
